/**
 * C10's self-service routes, mounted by P11.
 *
 * Same three rules `routes.ts` states and for the same reasons: everything under `/me`,
 * **no employee id in any path** (every `/api/v1/me/...` route resolves the employee
 * from the JWT, so a screen needing an id in its URL has reached for the wrong
 * endpoint), and each route names the code the Employee role actually holds.
 */

import type { RouteRecordRaw } from 'vue-router'

import { ESS_C10_PERMISSIONS } from '@/modules/ess/permissionsC10'

export const ESS_C10_ROUTES: RouteRecordRaw[] = [
  {
    path: '/me/roster',
    name: 'ess-roster',
    component: () => import('@/modules/ess/MyRosterView.vue'),
    meta: { titleKey: 'ess.routeTitles.roster', permission: ESS_C10_PERMISSIONS.rosterReadOwn },
  },
  {
    path: '/me/clock',
    name: 'ess-clock',
    component: () => import('@/modules/ess/MyClockView.vue'),
    meta: { titleKey: 'ess.routeTitles.clock', permission: ESS_C10_PERMISSIONS.clockSelf },
  },
  {
    path: '/me/service-charge',
    name: 'ess-service-charge',
    component: () => import('@/modules/ess/MyServiceChargeView.vue'),
    meta: {
      titleKey: 'ess.routeTitles.serviceCharge',
      permission: ESS_C10_PERMISSIONS.serviceChargeSelf,
    },
  },
  {
    path: '/me/employment',
    name: 'ess-employment',
    component: () => import('@/modules/ess/MyEmploymentHistoryView.vue'),
    meta: {
      titleKey: 'ess.routeTitles.employment',
      permission: ESS_C10_PERMISSIONS.selfAssignments,
    },
  },
  {
    path: '/me/year-end',
    name: 'ess-year-end',
    component: () => import('@/modules/ess/MyYearEndStatementsView.vue'),
    meta: { titleKey: 'ess.routeTitles.yearEnd', permission: ESS_C10_PERMISSIONS.yearEndSelf },
  },
]

/** Paths for the C10 self-service screens, for the tab strip and for links elsewhere. */
export const ESS_C10_PATHS = {
  roster: '/me/roster',
  clock: '/me/clock',
  serviceCharge: '/me/service-charge',
  employment: '/me/employment',
  yearEnd: '/me/year-end',
} as const
